<script lang="ts" module>
  export const SIZE_W = { s: 100, m: 270, l: 480, xl: 667 }
  export const SIZE_H = { s: 100, m: 250, l: 430, xl: 667 }
  type Widths = keyof typeof SIZE_W
  export const imageSizes: { size: Widths; label: string }[] = [
    { size: "s", label: "Small" },
    { size: "m", label: "Medium" },
    { size: "l", label: "Large" },
    { size: "xl", label: "Extra Large" }
  ]
</script>

<script lang="ts">
  import Modal from "$app/components/Modal.svelte"

  type InsertImgType = {
    file: ActiveStorageType
    width: number
    height: number
  }

  let props = $props()
  let {
    file,
    ondeletefile,
    oninsertimage
  }: {
    file: ActiveStorageType
    ondeletefile: (file: ActiveStorageType) => void
    oninsertimage: (data: InsertImgType) => void
  } = props

  const blob: BlobType =
    file.blob || ({ filename: "", content_type: "", url: "" } as BlobType)
  const filename: string = blob.filename || file?.filename
  const content_type: string = blob.content_type || file?.content_type
  const url: string = blob.url || file?.url

  const isImage = /image.+/.test(content_type)
  let showImageModal = $state(false)

  let selectedSize: Widths = $state(imageSizes[0].size)

  let showCopy = $state(false)
  function copyUrl(): void {
    showCopy = true
    navigator.clipboard.writeText(url)
    setTimeout(() => (showCopy = false), 2000)
  }

  let imgElem = $state<HTMLImageElement | undefined>()

  function insertImage(): void {
    if (!imgElem) return
    const w = imgElem.naturalWidth
    const h = imgElem.naturalHeight
    const selectedSizeRange = w >= h ? SIZE_W : SIZE_H

    let width: number
    let height: number

    const selDim = selectedSizeRange[selectedSize]
    // Check if the size is H or W
    if (selectedSizeRange["xl"] === SIZE_H["xl"]) {
      ;[width, height] = [(w / h) * selDim, selDim]
    } else {
      ;[width, height] = [selDim, (h / w) * selDim]
    }
    showImageModal = false
    oninsertimage({ file, width, height })
  }
</script>

<li
  class="flex gap-2 items-center mb-2 border-b border-gray-100"
  class:bg-blue-50={file._selected}
>
  {#if isImage}
    <img src={url} alt={filename} class="w-20 max-h-20" bind:this={imgElem} />
  {:else}
    <span class="w-10 h-8 bg-gray-100"></span>
  {/if}
  <div class="w-full text-ellipsis overflow-hidden" title={filename}>
    {filename}
  </div>

  <div class="flex gap-2">
    {#if isImage && 0}
      <button
        class="btn btn-sm secondary whitespace-nowrap"
        class:!bg-blue-100={showCopy}
        type="button"
        onclick={() => (showImageModal = true)}
      >
        Insert
      </button>
    {/if}
    <button
      class="btn btn-sm secondary whitespace-nowrap"
      class:!bg-blue-100={showCopy}
      type="button"
      onclick={copyUrl}
    >
      {showCopy ? "Copied" : "Copy URL"}
    </button>

    <button
      class="btn btn-sm secondary"
      type="button"
      onclick={() => ondeletefile(file)}
    >
      Delete
    </button>
  </div>
</li>

<Modal bind:open={showImageModal}>
  Select the size of your image
  {#each imageSizes as size}
    <label>
      <input type="radio" bind:group={selectedSize} value={size.size} />
      {size.label}
    </label>
  {/each}

  <button class="btn btn-primary btn-sm mt-2" onclick={insertImage}>
    Insert image
  </button>
</Modal>
